import type React from "react";
import {IconButton, Tooltip} from "@mui/material";
import {InfoOutlined} from "@mui/icons-material";
import HelpIcon from "~/icons/svg/HelpIcon.svg?react";

/**
 * A help icon whose content shows in the design's tooltip on hover (or focus, or a long press on touch). The tooltip
 * is interactive: it stays while the mouse moves into it, so its text can be read and selected.
 */
export const HelpComponent: React.FC<{
    helpContent: React.ReactNode;
    /** A small outlined info icon (16px, like the KPI tooltips) instead of the help icon. */
    small?: boolean,
}> = ({helpContent, small}) => (
    <Tooltip
        title={helpContent}
        placement="bottom"
        arrow
        leaveDelay={150}
        // Screen readers announce the help text as the icon's description (its name stays "Help").
        describeChild
    >
        <IconButton aria-label="Help" size={small ? 'small' : 'medium'}
                    sx={small ? {p: 0.5, color: 'text.secondary'} : undefined}>
            {small ? <InfoOutlined sx={{fontSize: 16}}/> : <HelpIcon width={20} height={20}/>}
        </IconButton>
    </Tooltip>
);
